// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homepage {
  margin-top: 25px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
@media (max-width: 480px) {
  .homepage {
    margin-top: 15px;
  }
}
.homepage__content {
  padding-top: 25px;
  padding-bottom: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
@media (max-width: 480px) {
  .homepage__content {
    padding-top: 15px;
    padding-bottom: 10px;
  }
}
.homepage__addproject {
  font-size: 22px;
  font-weight: 600;
  cursor: pointer;
  color: rgb(7, 7, 7);
}
.homepage__addproject:hover {
  color: #6600ff;
}
@media (max-width: 480px) {
  .homepage__addproject {
    font-size: 20px;
  }
}
.homepage__items {
  padding-top: 20px;
}
@media (max-width: 480px) {
  .homepage__items {
    padding-top: 10px;
  }
}
.homepage__title-1 {
  font-size: 20px;
  font-weight: 600;
  cursor: pointer;
  color: rgb(7, 7, 7);
}
.homepage__title-1:hover {
  color: #6600ff;
}
.homepage__title {
  font-size: 20px;
  font-weight: 600;
  color: rgb(7, 7, 7);
}
.homepage__item {
  font-size: 18px;
  font-weight: 400;
  color: #2c2b2b;
  cursor: pointer;
}
.homepage__item:hover {
  color: #6600ff;
}
@media (max-width: 480px) {
  .homepage__item {
    font-size: 16px;
  }
}
.homepage .bold {
  font-size: 20px;
  font-weight: 600;
  color: rgb(7, 7, 7);
}
.homepage .bold:hover {
  color: #6600ff;
}

.counter {
  display: block;
  margin: 0 auto;
  width: 500px;
  height: 215px;
  background-color: #2c2b2b;
  border-radius: 10px;
}
@media (max-width: 535px) {
  .counter {
    width: 450px;
  }
}
@media (max-width: 480px) {
  .counter {
    height: 180px;
    width: 380px;
  }
}
@media (max-width: 420px) {
  .counter {
    height: 180px;
    width: 350px;
  }
}
.counter__content {
  padding-top: 20px;
}
.counter__item {
  font-size: 16px;
  color: #ffffff;
  text-align: center;
}
@media (max-width: 480px) {
  .counter__item {
    font-size: 14px;
  }
}

.installation-billing {
  margin-top: 25px;
}
.installation-billing__title {
  font-size: 18px;
  font-weight: 600;
  color: rgb(7, 7, 7);
  margin-bottom: 25px;
}
.installation-billing__table {
  background-color: #bbbbbb;
}`, "",{"version":3,"sources":["webpack://./src/components/HomePage/style.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;AACJ;AAAI;EALJ;IAMQ,gBAAA;EAGN;AACF;AAFI;EACI,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAIR;AAHQ;EAPJ;IAQQ,iBAAA;IACA,oBAAA;EAMV;AACF;AAHI;EACI,eAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAKR;AAJQ;EACI,cAAA;AAMZ;AAJQ;EARJ;IASQ,eAAA;EAOV;AACF;AAJI;EACI,iBAAA;AAMR;AALQ;EAFJ;IAGQ,iBAAA;EAQV;AACF;AALI;EACI,eAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAOR;AANQ;EACI,cAAA;AAQZ;AAJI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AAMR;AAHI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAKR;AAJQ;EACI,cAAA;AAMZ;AAJQ;EARJ;IASQ,eAAA;EAOV;AACF;AAJI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AAMR;AALQ;EACI,cAAA;AAOZ;;AAEA;EACI,cAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AACJ;AAAI;EAPJ;IAQQ,YAAA;EAGN;AACF;AAFI;EAVJ;IAWQ,aAAA;IACA,YAAA;EAKN;AACF;AAJI;EAdJ;IAeQ,aAAA;IACA,YAAA;EAON;AACF;AALI;EACI,iBAAA;AAOR;AAJI;EACI,eAAA;EACA,cAAA;EACA,kBAAA;AAMR;AALQ;EAJJ;IAKQ,eAAA;EAQV;AACF;;AAFA;EACI,gBAAA;AAKJ;AAJI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AAMR;AAHI;EACI,yBAAA;AAKR","sourcesContent":[".homepage {\n    margin-top: 25px;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    @media(max-width: 480px) {\n        margin-top: 15px;\n    }\n    &__content {\n        padding-top: 25px;\n        padding-bottom: 50px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        flex-direction: column;\n        @media(max-width: 480px) {\n            padding-top: 15px;\n            padding-bottom: 10px;\n        }\n    }\n\n    &__addproject {\n        font-size: 22px;\n        font-weight: 600;\n        cursor: pointer;\n        color: rgb(7,7,7);\n        &:hover {\n            color: #6600ff;\n        }\n        @media(max-width: 480px) {\n            font-size: 20px;\n        }\n    }\n\n    &__items {\n        padding-top: 20px;\n        @media(max-width: 480px) {\n            padding-top: 10px;\n        }\n    }\n\n    &__title-1 {\n        font-size: 20px;\n        font-weight: 600;\n        cursor: pointer;\n        color: rgb(7,7,7);\n        &:hover {\n            color: #6600ff;\n        }\n    }\n\n    &__title {\n        font-size: 20px;\n        font-weight: 600;\n        color: rgb(7,7,7);\n    }\n\n    &__item {\n        font-size: 18px;\n        font-weight: 400;\n        color: #2c2b2b;\n        cursor: pointer;\n        &:hover {\n            color: #6600ff;\n        }\n        @media(max-width: 480px) {\n            font-size: 16px;\n        }\n    }\n\n    .bold {\n        font-size: 20px;\n        font-weight: 600;\n        color: rgb(7,7,7);\n        &:hover {\n            color: #6600ff;\n        }\n    }\n\n   \n}\n\n//Counter\n\n.counter {\n    display: block;\n    margin: 0 auto;\n    width: 500px;\n    height: 215px;\n    background-color: #2c2b2b;\n    border-radius: 10px; \n    @media(max-width: 535px) {\n        width: 450px;\n    }\n    @media(max-width: 480px) {\n        height: 180px;\n        width: 380px;\n    }\n    @media(max-width: 420px) {\n        height: 180px;\n        width: 350px;\n    }\n\n    &__content {\n        padding-top: 20px;\n    }\n\n    &__item {\n        font-size: 16px;\n        color: #ffffff;\n        text-align: center;\n        @media(max-width: 480px) {\n            font-size: 14px;\n        }\n    }\n}\n\n//istallation-billing \n\n.installation-billing {\n    margin-top: 25px;\n    &__title {\n        font-size: 18px;\n        font-weight: 600;\n        color: rgb(7,7,7);\n        margin-bottom: 25px;\n    }\n\n    &__table {\n        background-color: #bbbbbb;\n        \n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
